import React from 'react'

export default function AboutUs() {
  return (
    <iframe
      src="/about.html"
      className="w-full h-screen border-0"
      title="About Us"
      // allowFullScreen
    />
  )
}